/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Components, Theme } from "@mui/material/styles";

export const muiPaperStyle = (): Components<Theme>["MuiPaper"] => ({
  defaultProps: {
    elevation: 4,
  },
  styleOverrides: {
    rounded: {
      borderRadius: "0.5rem",
    },
  },
});
